import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS_WITH_SUBSCRIPTION_DATA_AND_TTS = [
  'editVideoButtonPressed',
  'transcriptionPageShown',
  'trialPageViewed',
  'dubButtonPressed',
  'redubButtonPressed',
  'videoIsGenerated',
  'downloadTranscription',
  'downloadTranscriptionWithSpeakers',
  'downloadTranslation',
  'downloadTranslationWithSpeakers',
  'downloadAudio',
  'downloadAudioBackground',
  'downloadVideo',
  'downloadOriginalVideo',
  'rewriteTooltipShownTooManyChar',
  'rewriteButtonPressedMore',
  'applyRewrittenPressedAIRewrite',
  'rewriteButtonPressed',
  'newSegmentAdded',
  'textEditedSegmentTranscript',
  'textEditedSegmentTranslation',
  'segmentDeleted',
  'newSpeakerAdded',
  'clickMergeSegments',
  'timestampEdited',
  'speakersEdited',
  'speakersVoiceEdited',
  'advancedEditorSegmentDelete',
  'splitSegmentsModalShown',
  'clickSplitSegments',
  'srcSplitSegments',
  'dstSplitSegment',
  'srcSplitSegmentSuccess',
  'dstSplitSegmentSuccess',
  'segmentPreviewGenerated',
  'segmentPreviewPlayed',
  'segmentPreviewAccepted',
  'translationVariantSelected',
  'translationVariantsExpanded',
  'translationVariantsCollapsed',
  'transcriptVersionsViewed',
  'editorSegmentFocused',
  'editorSegmentAction',
  'editorSegmentAttentionChanged',
  'editorPlaybackSpeedChanged',
  'editorShortcutPanelOpened',
  'editorAdoptionOnboardingShown',
] as const;

const EVENTS_WITH_SUBSCRIPTION_DATA = ['ttsDownloadVideo'] as const;

const srtEditorEventsWithSubscriptionDataAndTTS = getMappedEvents([...EVENTS_WITH_SUBSCRIPTION_DATA_AND_TTS], {
  shouldSendRaskTTSData: true,
  shouldSendSubscriptionData: true,
});

const srtEditorEventsWithSubscriptionData = getMappedEvents([...EVENTS_WITH_SUBSCRIPTION_DATA], {
  shouldSendSubscriptionData: true,
});

export const srtEditorEvents = [...srtEditorEventsWithSubscriptionDataAndTTS, ...srtEditorEventsWithSubscriptionData];
